import React from 'react';
import { Slider as MuiSlider, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colorPrimary } from '../../Styles/Colors';

const StyledSlider = styled(MuiSlider)(({ theme }) => ({
  color: colorPrimary,  
  height: 4, 
  '& .MuiSlider-track': {
    border: 'none',
    backgroundColor: colorPrimary,
    height: 4,
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: colorPrimary,
    border: '2px solid #fff',
    boxShadow: '0 3px 1px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.13), 0 0 0 1px rgba(0,0,0,0.02)',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: '0px 0px 0px 8px rgba(156, 39, 176, 0.16)',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-rail': {
    color: '#e0e0e0',
    opacity: 1,
    height: 4,
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: colorPrimary,
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
}));

const Slider = ({ 
  value, 
  onChange, 
  label, 
  min = 0, 
  max = 100, 
  step = 1, 
  style,
  showValue = false,
  ...props 
}) => {
  return (
    <Box 
      sx={{
        display: 'flex',
        width: '180px',
        padding: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        ...style
      }}
    >
      {label && (
        <Typography 
          id="slider-label" 
          gutterBottom
          sx={{ 
            fontSize: '14px', 
            fontWeight: 500, 
            color: '#333',
            marginBottom: '12px',
            alignSelf: 'flex-start'
          }}
        >
          {label}
        </Typography>
      )}
      <StyledSlider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        aria-labelledby={label ? "slider-label" : undefined}
        valueLabelDisplay={showValue ? "on" : "auto"}
        sx={{ width: '100%' }}
        {...props}
      />
    </Box>
  );
};

export default Slider;
